import { __extends } from "tslib";
import React from 'react';
import { Provider } from '@ekuaibao/datagrid/esm/State';
import { Language } from '@ekuaibao/datagrid/esm/i18n/Language';
import { i18nHelper } from '../../i18n/utils';
export var i18nText = function () { return ({
    groupPanelEmptyText: i18n.get('拖拽表头字段至此处可进行分组查看'),
    columnChooserEmptyText: i18n.get('拖拽表头字段至此处可隐藏'),
    columnChooserTitle: i18n.get('编辑表头字段'),
    cancelRowChanges: i18n.get('取消'),
    saveRowChanges: i18n.get('保存'),
    addRow: i18n.get('新增'),
    editRow: i18n.get('编辑'),
    deleteRow: i18n.get('删除'),
    noData: i18n.get('暂无数据'),
    ascendingText: i18n.get('升序'),
    descendingText: i18n.get('降序'),
    clearText: i18n.get('清空$'),
    submit: i18n.get('确定'),
    reset: i18n.get('重置'),
    columnChooserTip: i18n.get('选择要展示的列$'),
    columnDisplaySetting: i18n.get('列展示设置$'),
    checkAll: i18n.get('全选'),
    searchPlaceholder: i18n.get('搜索字段'),
    selectedColumnsLabel: i18nHelper(i18n.get('已选择：__k0列')),
    manualSizeForOnePage: function (args) { return i18n.get('manualSizeForOnePage', args); },
    autoSizeForOnePage: function (args) { return i18n.get('autoSizeForOnePage', args); },
    prevPage: i18n.get('上一页'),
    nextPage: i18n.get('下一页'),
    manualOptionJump: i18n.get('翻页，每页加载'),
    manualNumbers: i18n.get('条'),
    autoOptionJump: function (args) { return i18n.get('autoOptionJump', args); },
    cancel: i18n.get('取消'),
    pageJumpConfig: i18n.get('跳转到第'),
    pageJumpNumber: i18n.get('页'),
    selectAllText: i18n.get('选择全部'),
    selectedLabel: function (args) { return i18n.get('selectedLabel', args); },
    selectedField: i18n.get('已选择字段'),
    canSelectField: i18n.get('可选择字段'),
    selectAll: i18n.get('全部选择'),
    cancelAll: i18n.get('取消全部'),
    DragOrderAble: i18n.get('可拖拽排序'),
    selectInLeftBox: i18n.get('请从左侧框中点击选择字段'),
    transforEmpty: i18n.get('请选择要转移的字段'),
    Equal: i18n.get('等于'),
    Greater: i18n.get('大于'),
    GreaterOrEqual: i18n.get('大于等于'),
    Less: i18n.get('小于'),
    LessOrEqual: i18n.get('小于等于'),
    NotEqual: i18n.get('不等于'),
    Customize: i18n.get('自定义区间'),
    okText: i18n.get('确定_DONE'),
    cancelButtonText: i18n.get('取消'),
}); };
var LocaleProvider = (function (_super) {
    __extends(LocaleProvider, _super);
    function LocaleProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.i18nText = i18nText();
        return _this;
    }
    LocaleProvider.prototype.render = function () {
        return (React.createElement(Provider, null,
            React.createElement(Language, { texts: this.i18nText }),
            this.props.children));
    };
    return LocaleProvider;
}(React.PureComponent));
export { LocaleProvider };
